





















































































































































































import {
  apiMarketingCouponGetCouponReceiveInfo,
  apiMarketingCouponReceiveOpen,
  apiPageConfigGetStateContentByApp,
} from '@/api'
import { computed } from '@vue/composition-api'
import { dcb } from '@dcb/jssdk'
import { defineClassComponent, useApi } from '@/hooks'
import { devOrProd, prepareData, submit, Track } from '@/utils'
import { loadResource, LoadResourceUrlType, values } from 'vtils'
import { PageUtils } from '@/components'
import { WomenDayImages } from './images'

const 优惠券ID: string[] = devOrProd(
  ['8aaa92a17f540824017f5457897e0020'],
  [
    '8aaad9497e961ad7017f53c750c70316',
    '8aaa86267e960f53017f53ca63e90360',
    '8aaae8ad7e96146c017f53cbdd045443',
  ],
)

const 专场券ID: string[] = devOrProd(
  ['8aaa92a17f540824017f5457897e0020'],
  [
    '8aaa86267e960f53017f53cebde60362',
    '8aaad9497e961ad7017f53d0f7380319',
    '8aaad9497e961ad7017f53d27a62031b',
  ],
)

const 优惠券使用链接: string = devOrProd(
  'https://baidu.com',
  'https://h5.gogpay.cn/h5/app/duoduo-mall/#/topic/index?id=8aaab123794bc0ee0179f4ce2aa82ffa&isFull=true&isLogin=true&isAuth=true',
)

const 专场券使用链接: string = devOrProd(
  'https://baidu.com',
  'https://h5.gogpay.cn/h5/app/duoduo-mall/#/topic/index?id=8aaad5707b96bc3e017b9a51e6dc02e2&groupId=8aaaadb77e941096017ed1cdd416439b&isFull=true&isLogin=true&isAuth=true',
)

export default defineClassComponent(
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '约惠女神节',
        }))
      }

      shareParams = PageUtils.defineShareParams(() => ({
        title: '38女神节特惠！大牌美妆7折起、买茶送小黄鸭电器等超值活动！',
        desc: '所有女神不要错过！',
        cover: 'https://cdn-resource.gogpay.cn/npm/_/1646388740k59MOh.png',
      }))

      apiData = useApi(async () => {
        const data = await prepareData({
          images: loadResource(
            values(WomenDayImages).map(url => ({
              type: LoadResourceUrlType.img,
              path: url,
            })),
          ),
          电器数据: apiPageConfigGetStateContentByApp({
            stateId: devOrProd(
              '8aaa8c5b7f538d3a017f54e8f920003b',
              '8aaaeba77e7cb5b1017f5464496f04c0',
            ),
            pageIndex: 1,
            pageSize: 100,
          }).then(res => res.list),
          美妆数据_上: apiPageConfigGetStateContentByApp({
            stateId: devOrProd(
              '8aaa8c5b7f538d3a017f54eaabb1003e',
              '8aaaeba77e7cb5b1017f54651b6c04c5',
            ),
            pageIndex: 1,
            pageSize: 100,
          }).then(res => res.list),
          美妆数据_中: apiPageConfigGetStateContentByApp({
            stateId: devOrProd(
              '8aaa8c5b7f538d3a017f54ec37220048',
              '8aaaeba77e7cb5b1017f54662a0c04ca',
            ),
            pageIndex: 1,
            pageSize: 100,
          }).then(res => res.list),
          美妆数据_下: apiPageConfigGetStateContentByApp({
            stateId: devOrProd(
              '8aaa8c5b7f538d3a017f54ed09a1004d',
              '8aaaeba77e7cb5b1017f546709e404cf',
            ),
            pageIndex: 1,
            pageSize: 100,
          }).then(res => res.list),
          秒杀数据: apiPageConfigGetStateContentByApp({
            stateId: devOrProd(
              '8aaa8c5b7f538d3a017f54ee8e710050',
              '8aaaeba77e7cb5b1017f5467c6fb04d4',
            ),
            pageIndex: 1,
            pageSize: 1,
          }).then(res => res.list),
        })
        return data
      })

      couponApiData = useApi(async () => {
        const data = await prepareData({
          优惠券: Promise.all(
            优惠券ID.map(id =>
              apiMarketingCouponGetCouponReceiveInfo({
                couponActId: id,
              }),
            ),
          ).then(res => {
            let canReceive = false
            for (const item of res) {
              if (item.receiveStatus === 1) {
                return '已领取'
              }
              if (item.receiveStatus === 0) {
                canReceive = true
              }
            }
            return canReceive ? '可领取' : '已领完'
          }),
          专场券: Promise.all(
            专场券ID.map(id =>
              apiMarketingCouponGetCouponReceiveInfo({
                couponActId: id,
              }),
            ),
          ).then(res => {
            let canReceive = false
            for (const item of res) {
              if (item.receiveStatus === 1) {
                return '已领取'
              }
              if (item.receiveStatus === 0) {
                canReceive = true
              }
            }
            return canReceive ? '可领取' : '已领完'
          }),
        })
        return data
      })

      电器数据 = computed(() => this.apiData.data.电器数据)

      美妆数据_上 = computed(() => this.apiData.data.美妆数据_上)

      美妆数据_中 = computed(() => this.apiData.data.美妆数据_中)

      美妆数据_下 = computed(() => this.apiData.data.美妆数据_下)

      秒杀数据 = computed(() => this.apiData.data.秒杀数据)

      优惠券领取状态 = computed(() => this.couponApiData.data.优惠券)

      专场券领取状态 = computed(() => this.couponApiData.data.专场券)

      领取优惠券 = () => {
        submit(async $ => {
          $.start('领取中...')
          await Promise.all(
            优惠券ID.map(id =>
              apiMarketingCouponReceiveOpen({
                couponActId: id,
              }),
            ),
          )
          await this.couponApiData.refresh()
          await $.success('领取成功')
        })
      }

      使用优惠券 = () => {
        dcb.navigateTo({
          url: 优惠券使用链接,
        })
      }

      领取专场券 = () => {
        submit(async $ => {
          $.start('领取中...')
          await Promise.all(
            专场券ID.map(id =>
              apiMarketingCouponReceiveOpen({
                couponActId: id,
              }),
            ),
          )
          await this.couponApiData.refresh()
          await $.success('领取成功')
        })
      }

      使用专场券 = () => {
        dcb.navigateTo({
          url: 专场券使用链接,
        })
      }
    },
)
